export const tailwindConfig = {
  fontFamily: {
    sans: ['Poppins', 'sans-serif'],
    montserrat: ['Poppins', 'sans-serif'],
  },
  extend: {
    colors: {
      sunrise: {
        50: '#FFF4EA',
        100: '#FFE4CC',
        200: '#FFC999',
        300: '#FFAD66',
        400: '#FF9233',
        500: '#FF7A00',
        600: '#DB6700',
        700: '#B75400',
        800: '#934200',
        900: '#6E3000',
        950: '#451D00',
      },
      leftArrow: '#111111',
    },
    fontSize: {
      heading: ['1rem', { lineHeight: '1.5rem', fontWeight: '700' }],
      body: ['0.875rem', { lineHeight: '1.25rem', fontWeight: '500' }],
      '2xs': ['0.625rem', '0.75rem'],
    },
    height: {
      26: '6.5rem',
    },
    width: {
      26: '6.5rem',
    },
    minHeight: {
      18: '4.5rem',
    },
    borderWidth: {
      '1.5': '1.5px',
    },
  }
};
